import "@fontsource/dm-sans";
import "@fontsource/fredoka-one";
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import ReactPlayer from 'react-player';
import { SignUpForm } from "../../components/Form/SignUp";

// import images
import banner from "../../assets/images/banner1.svg";
import logo from "../../assets/images/logo-color.svg";
import { Row } from "reactstrap";
import { ApiResponseToast } from "../../components/Common/ApiResponseToast";

export const SignUp = () => {
  const [playing, setPlaying] = React.useState(false)
  const [video, setVideo] = React.useState(0)

  return (
    <>
    <div className="login-body">

        <Row>
            <ApiResponseToast />
        </Row>
        
        <div className="float-container">


            <div className="float-child1">
                <div className="banner"> 
                <div className="banner-txt">Telco CPQ</div>
                <div className="banner-h1">Generate quick and accurate offers</div>
                <img className="banner-image" width="500" src={banner} alt="ofca-banner" />
                </div>
            </div>

            <div className="float-child2">

                <main className="login-main">
                    <label className="login-label" htmlFor="tab2"> 
                        <div className="btn-video"> Learn about <br /> ofca <br /><FontAwesomeIcon className="youtube-play" icon={faYoutube}/></div> 
                    </label>
                    <input id="tab3" type="radio" name="tabs" value={0} checked={video === 0} onChange={(e) => setVideo(Number(e.currentTarget.value))} />
                    <label onClick={() => setPlaying(false)} className="login-label" htmlFor="tab3"> <img className="login-logo" src={logo} alt="ofca.io" /> </label>
                    <input id="tab1" type="radio" name="tabs" value={1} checked={video === 1} onChange={(e) => setVideo(Number(e.currentTarget.value))} />
                    <input id="tab2" type="radio" name="tabs" value={2} checked={video === 2} onChange={(e) => setVideo(Number(e.currentTarget.value))} />
                    {
                        video < 2?
                            <section className="login-section" id="content1">
                                <h1 className="login-h1"> <strong> Welcome.</strong> Please register.</h1>
                                <div className="login-center">
                                        <SignUpForm />

                                </div>
                            </section>
                        : null
                    }
                    {
                        video === 2?
                            <section className="login-section" id="content2">
                                <div className="video-container"> 
                                    <ReactPlayer 
                                        className="video-player" 
                                        playing={playing}
                                        url='https://www.youtube.com/watch?v=fk0JHFLryQc' 
                                        config={{
                                            youtube: {
                                                playerVars: 
                                                {   playsinline: 1,
                                                    modestbranding : 1,
                                                    rel : 0, 
                                                    controls : true                                                     
                                                }
                                            }
                                        }}  />
                                     </div>
                                <br />
                                <div className="login-center"> <label onClick={() => setPlaying(false)} htmlFor="tab1"> <span className='regback'>&nbsp;&nbsp;Continue registering&nbsp;&nbsp;</span></label>
                                </div>
                            </section>
                        : null
                    }
                </main>
            </div>
        </div>
    </div>
    
    
    </>
  );
};
